import React from "react";
import FieldPreview from "./FieldPreview";
import ButtonActionIcon from "../BuilderComponents/ButtonActionIcon";
import { generateObjectId } from "../../utils/objectIdUtils";

const TablePreview = ({ config, saveConfig, classes, onClickElement }) => {
  const { columns, rows } = config.config;
  const { show_border, show_header, table_style } = config.options;

  const handleEvents = (type, info = null) => {
    onClickElement({
      type,
      info
    });
  };

  const addColumn = () => {
    const newColumn = { cell_id: generateObjectId(), title: `New Column` };
    const newRows = rows.map((row) => [...row, { cell_id: generateObjectId(), custom_text: "" }]);

    saveConfig({
      ...config,
      config: {
        ...config.config,
        columns: [...columns, newColumn],
        rows: newRows
      }
    });
  };

  const addRow = () => {
    const newRow = columns.map(() => ({ cell_id: generateObjectId(), custom_text: "" }));

    saveConfig({
      ...config,
      config: {
        ...config.config,
        rows: [...rows, newRow]
      }
    });
  };

  const tableStyles = {
    default: {
      border: show_border ? "1px solid black" : "none",
      width: "100%",
      borderCollapse: "collapse"
    },
    alt_row: {
      border: show_border ? "1px solid black" : "none",
      width: "100%",
      borderCollapse: "collapse",
      backgroundColor: "#ffffff"
    },
    alt_col: {
      border: show_border ? "1px solid black" : "none",
      width: "100%",
      borderCollapse: "collapse",
      backgroundColor: "#ffffff"
    }
  };

  const getRowStyle = (index) => {
    if (table_style === "alt_row") {
      return { backgroundColor: index % 2 === 0 ? "#f2f2f2" : "#ffffff" };
    } else {
      return {};
    }
  };

  const getCellStyle = (colIndex) => {
    if (table_style === "alt_col") {
      return { backgroundColor: colIndex % 2 === 0 ? "#f2f2f2" : "#ffffff" };
    } else {
      return {};
    }
  };

  const handleRowCellClick = (e, cell, rowIndex, colIndex) => {
    e.stopPropagation();
    handleEvents("edit_row_cell", { cell, rowIndex, colIndex });
  };
  const handleColumnCellClick = (e, cell, colIndex) => {
    e.stopPropagation();
    handleEvents("edit_column_cell", { cell, colIndex });
  };

  const handleSettingsClick = (e) => {
    e.stopPropagation();
    handleEvents("edit_table_settings");
  };

  const handleDeleteRow = (e, rowIndex) => {
    e.stopPropagation();
    const newRows = [...rows];
    newRows.splice(rowIndex, 1);
    saveConfig({
      ...config,
      config: {
        ...config.config,
        rows: newRows
      }
    });
  };

  const handleDeleteColumn = (e, colIndex) => {
    e.stopPropagation();
    const newColumns = [...columns];
    newColumns.splice(colIndex, 1);
    const newRows = rows.map((subArray) => subArray.slice(0, colIndex).concat(subArray.slice(colIndex + 1)));

    saveConfig({
      ...config,
      config: {
        ...config.config,
        columns: newColumns,
        rows: newRows
      }
    });
  };

  return (
    <div
      className="table-container z-tableView"
      style={{ position: "relative", display: "inline-block", width: "100%" }}
    >
      <ButtonActionIcon className="settings-btn" type="settings" onClick={handleSettingsClick} />

      <table className={`${classes}`} style={tableStyles[table_style] || tableStyles.default}>
        {show_header && (
          <thead className="z-table-header">
            <tr>
              {columns.map((col, colIndex) => (
                <th
                  key={col.cell_id}
                  onClick={(e) => handleColumnCellClick(e, col, colIndex)}
                  style={{
                    border: show_border ? "1px solid var(--z-rv-table-border)" : "none",
                    cursor: "pointer",
                    position: "relative"
                  }}
                  className={col.classes?.join(" ") || ""}
                >
                  <span>{col.title}</span>
                  <ButtonActionIcon
                    className="position_absolute add-row-btn"
                    type="delete"
                    size="xsm"
                    onClick={(e) => handleDeleteColumn(e, colIndex)}
                    style={{ top: "-1px" }}
                  />
                </th>
              ))}
            </tr>
          </thead>
        )}
        <tbody>
          {rows.map((row, rowIndex) => (
            <tr key={`row-${rowIndex}`} style={getRowStyle(rowIndex)}>
              {row.map((cell, colIndex) => (
                <>
                  <td
                    key={cell.cell_id}
                    style={{
                      border: show_border ? "1px solid var(--z-rv-table-border)" : "none",
                      cursor: "pointer",
                      ...getCellStyle(colIndex),
                      position: "relative"
                    }}
                    onClick={(e) => handleRowCellClick(e, cell, rowIndex, colIndex)}
                    className={cell.classes?.join(" ") || ""}
                  >
                    <span>
                      {cell.custom_text ? cell.custom_text : cell.id && <FieldPreview config={cell} classes={""} />}
                      {colIndex === 0 && (
                        <ButtonActionIcon
                          className="position_absolute left_0 add-column-btn"
                          type="delete"
                          onClick={(e) => handleDeleteRow(e, rowIndex)}
                          style={{ left: "-1px" }}
                          size="xsm"
                        />
                      )}
                    </span>
                  </td>
                </>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      <ButtonActionIcon className="add-column-btn" type="add" onClick={addColumn} />
      <ButtonActionIcon className="add-row-btn" type="add" onClick={addRow} />
    </div>
  );
};

export default TablePreview;
